import { IZone } from "@nju/data-access-portal-dashboard";
import { IVoicePackage } from "@nju/data-access-portal-product";
import { Icon } from "@nju/icons";
import { Separator, Text, Tooltip } from "@nju/ui";
import {
  formatDate,
  parseMinutesToSeconds,
  parseSecondsToMinutes,
} from "@nju/utils";

interface IInternationalPackageProps {
  testId?: string;
  zone: IZone["name"];
  voicePackage: IVoicePackage;
  zoneName: string | undefined;
}

export function InternationalPackage({
  testId,
  zone,
  voicePackage,
  zoneName,
}: IInternationalPackageProps) {
  const internationalCalls = voicePackage.internationalCalls?.find(
    (intPackage) => {
      return intPackage.zone === zone;
    },
  );

  if (!internationalCalls || !zone) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <>
      <Separator size="s" />
      <Text
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "l",
        }}
        weight="bold"
      >
        {zoneName} - dokupiony pakiet
      </Text>
      <Separator size="xxs" tone="invisible" />
      {internationalCalls.balances?.[0]?.currentValue &&
        internationalCalls.balances?.[0]?.startingValue && (
          <>
            <Text className="mb-1" display="block" size="s">
              pozostało
            </Text>
            <Separator size="none" tone="invisible" />
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "l",
              }}
              testId={testId}
            >
              <Text
                size={{
                  "@onlyMobile": "m",
                  "@fromTablet": "keyM",
                }}
                weight="bold"
              >
                {parseMinutesToSeconds(
                  internationalCalls.balances[0].currentValue,
                )}{" "}
              </Text>
              z{" "}
              {parseSecondsToMinutes(
                internationalCalls.balances[0].startingValue,
              )}{" "}
              min./SMS/MMS
            </Text>
            <div className="inline ml-2">
              <Tooltip content="1 minuta połączenia wychodzącego to równowartość 1 SMS-a lub 1 MMS-a wychodzącego. Połączenia rozliczane są sekundowo.">
                <Icon height={17} name="info-circle" tone="accent" width={17} />
              </Tooltip>
            </div>
          </>
        )}
      {internationalCalls.expiryDate && (
        <Text className="mt-1" display="block" size="s">
          pakiet będzie ważny do{" "}
          {formatDate(internationalCalls.expiryDate, true, ".", ", ")}
        </Text>
      )}
    </>
  );
}
